import { Component, OnInit} from '@angular/core';
import { FormsModule }   from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { env } from 'process';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {

  constructor( private route : ActivatedRoute, private _router: Router, private _auth: AuthService, private _notification: MatSnackBar ) { }

  res: string;

  message: string;

  dataLoading: boolean

  url = '/verify-account'

  token: string = 'abc'

  showVerificationMessage: boolean

  fieldTextType: boolean;

	ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        if(params.isRegistered === 'true') {
            this.message = 'Registration Successful! Please Login!';
        }
      });
  }
  
  onSubmit(f){
    this.dataLoading = true
    this._auth.login(f.value).subscribe( response=>{
      this.dataLoading = false
    	if(response.status == true){
    		this._auth.saveAccessToken(response.accessToken);
        this._auth.saveRefreshToken(response.refreshToken);
        this._router.navigate(['/'])
    	}
    	else{ 
    		this.res = response.message
    	}
    }, error => {
      this.dataLoading = false
      if(error.error && error.status == 400){
        if(error.error.accessToken){
          let tokenObj = error.error
          this.token = tokenObj.accessToken
          this.showVerificationMessage = true
        }else{
          this.openNotification(error.error.message)
        }
        
      }else if(error.status == 404){
        this.openNotification(error.error.message)
      }

    });
  	
  }
  
  openNotification(msg){
    this._notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

}
